var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"wrapper"},[_c('cabecalho',{attrs:{"tituloPagina":"Login"}}),_c('menuLateral')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }